import $ from 'jquery';
window.$ = $;
window.jQuery = $;

import './js/mobile-menu.js';
import './js/artists.js';
import './js/artist-details-modal.js';
import './js/feedback.js';
import './js/gsap.js';
import './js/scroll-to-top.js';

import './js/feedback-modal.js';
//import './js/feedback-swiper.js';
//import './js/feedback-raty.js';
